<template>
  <div class="popWrap">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full hasBtn" tabindex="-1" role="dialog">
          <div class="popHead">
            <h1 class="titH1">웰릭스 서비스 소개</h1>
          </div>
          <div class="popBody full">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section>
                <div class="formArea" v-html="contents"></div>
              </section>
              <!-- 본문 (e) -->
            </div>
          </div>
          <button type="button" class="btnIco_close" @click="$emit('close')"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as customjs from '../../../../static/js/m.front.js';
import ApiService from '@/common/api.service';

export default {
  name: 'customerCenter',
  data: function() {
    return {
      searchInput: null,

      contents: null,
    };
  },
  updated() {
    // content 이미지 관련 임시 function
    customjs.setImgSort();
  },
  mounted() {
    //customjs.init();
    //customjs.setBackgroudColor();
    ApiService.service('GET', '/board/welrixService')
      .then(({ data }) => {
        if (data.isSucceed) {
          this.contents = data.result.contents;
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });
  },
  methods: {},
};
</script>
